import moment from 'moment'

export default {
	methods: 
    {
		async searchsData(tipo)
		{
			this.statusDescargar=false
			this.resetDataGet()
			const await00 = this.onInit()	
			if(tipo==='afiliado')
			{			
				const await01 = this.updateDataForm({state: 'servicios_activos',data: []})	
				const await02 = this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})	
					await Promise.all([await00,await01,await02])

				let data = await this.getData({route: 'get_serviciosaporte', data: this.searchSw.value})
				if(data.length!=0)
				{									
					for (let i = 0; i < data.servicios_activos.length; i++) {
						let indexMultiple=_.findIndex(this.dataMultiple[this.namePath].multiple_servicios, ['name',data.servicios_activos[i].name])
						this.$set(this.dataMultiple[this.namePath].multiple_servicios,indexMultiple,data.servicios_activos[i])
					}

					const await1 = this.updateDataForm({state: 'datos_afiliado',data: data.datos_afiliado})
					const await2 = this.updateDataForm({state: 'info_afiliacion',data: data.info_afiliacion})
					const await3 = this.updateDataForm({state: 'servicios_activos',data: data.servicios_activos})	
						await Promise.all([await1,await2,await3])

					this.id_afiliacion_registro=data.afiliacion_registro.id

					this.novedad=2

					if(data.info_afiliacion.servicios===1)
					{
						this.mesPeriodo={id: data.info_afiliacion.mes_periodo, name: this.gettersDatalist('list_mes',data.info_afiliacion.mes_periodo)[0].name}
						this.anoPeriodo={id: data.info_afiliacion.ano_periodo, name: this.gettersDatalist('list_ano',data.info_afiliacion.ano_periodo)[0].name}
					}
					else 
					{						
						this.mesPeriodo = {id: this.fecha().fecha.mesHoy, name: this.gettersDatalist('list_mes',this.fecha().fecha.mesHoy)[0].name}
						this.anoPeriodo = {id: this.fecha().fecha.anoHoy, name: this.gettersDatalist('list_ano',this.fecha().fecha.anoHoy)[0].name}
					}
					this.statusDescargar=true
				}
				else 
				{
					this.statusDescargar=true	
				}
				
			}		
		},
		limpiarSearchs()
		{
			this.statusDescargar=false
			this.searchSw.value=''
			this.resetDataGet()
			this.mesPeriodo = {id: this.fecha().fecha.mesHoy, name: this.gettersDatalist('list_mes',this.fecha().fecha.mesHoy)[0].name}
			this.anoPeriodo = {id: this.fecha().fecha.anoHoy, name: this.gettersDatalist('list_ano',this.fecha().fecha.anoHoy)[0].name}
		},		
		
		invalidNovedad()
		{
			let fechaHoy=this.fecha().fecha.minHoy
			let mesActual=parseInt(moment(fechaHoy).format('MM'))
			let anoActual=parseInt(moment(fechaHoy).format('YYYY'))

			if(mesActual!=this.mesPeriodo || anoActual!=this.anoPeriodo)
			{
				this.errorsAportes='El periodo de aporte es diferente al mes actual'
				return false
			}
			this.errorsAportes=null
			return false
		}
	},
}